import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiTimelyMemoriesRoute } from './contract.timely.memories';
import { apiTimelyResourcesRoute } from './contract.timely.resources';
import { apiTimelyTimeEntryEventsRoute } from './contract.timely.time_entry_events';

extendZodWithOpenApi(z);

const c = initContract();

export const apiTimely = c.router({
  resources: apiTimelyResourcesRoute,
  timeEntryEvents: apiTimelyTimeEntryEventsRoute,
  memories: apiTimelyMemoriesRoute,
});
